import { ZONES } from '@/utils/constants';

const ZONES_WITH_DYNAMIC_CONTENT = [
    ZONES.RECENTLY_PLAYED_GAMES,
    ZONES.TRENDING_GAMES,
    ZONES.TOP_PICKS_FOR_YOU,
    ZONES.FAVORITES_GAMES
];

export const isZoneContentDynamicallyGenerated = (zoneUid?: string): boolean => {
    return !!zoneUid && ZONES_WITH_DYNAMIC_CONTENT.includes(zoneUid);
};

export const sortUidsByLaunchOrder = (uids: string[], launchedUids: string[]): string[] => {
    if (!launchedUids.length) return uids;

    const launchedSet = new Set(launchedUids);
    const uidSet = new Set(uids);

    const nonLaunchedUids = uids.filter((uid) => !launchedSet.has(uid));
    const launchedInZone = launchedUids.filter((uid) => uidSet.has(uid));

    return [...nonLaunchedUids, ...launchedInZone];
};
